export interface langTypes {
    code: string,
    display: string
}
// 언어코드 수정
export const DefaultLangCode = "ko"
export const langDefaultList: langTypes[] = [
    { code: "ko",       display: "한국어" },
    { code: "en",       display: "English" },
    { code: "zh",       display: "中文" },
    { code: "ms",       display: "Bahasa Melayu" },
    { code: "id",       display: "Bahasa Indonesia" },
]
export const sitelangs = ["ko", "en", "zh", "ms", "id"]